import React from 'react';
import styled from 'styled-components';

const Image = styled.img`
  grid-area: logo;
  max-height: 18px;
`;

export default ({ src }) => <Image src={src} />;
